export const scrollFn = (elem: string) => {
  // Use a smaller offset on mobile devices
  const isMobile = window.innerWidth <= 768;
  const yOffset = isMobile ? -75 : -130;
  const element = document.getElementById(elem);
  if (element) {
    const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
};
